// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Oxyoptima = {
  productCode: "SBOVZ-B7",
  productName: "Oxyoptima (Oxidative Stress)",
  ingredients: "Silybum marianum; Curcuminoids; Grape seed",
  overview:" Botanical and whole food Vitamin Supplement for Oxidative Stress",
  assay:" Beta Carotene: 420 mcg; Lycopene: 100 mcg; Lutein: 50 mcg; Zeaxanthin: 50 mcg; Vitamin E: 5 mg; Selenium: 20 mcg; Zinc: 2 mg; Silybum marianum extract: 100 mg; Curcuminoids-soft extract: 50 mg; Grape seed extract: 75 mg; Bixa Orellana: 50 mg;",
  coNutrients:"Secondary metabolites include C25 containing flavonoids, phytosterols, α-tocopherols, carotenoids and flavonoids.",
  studies:"",
  benefits:"Oxyoptima, the immune booster is an optimal blend of botanical extracts and whole-food vitamin complex that are highly synergistic and bio-available. It offers both lipid and water-soluble antioxidants that helps prevent free radicals damage and oxidative stress. It helps the body build immunity and enable fight viral infections.",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForRegenerativeHealth/Oxyoptima.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default Oxyoptima;
